module.exports = __webpack_public_path__ + "static/media/angle-left-blue.ff8c8a42.svg";